<template>
    <div class="app">
        <Header />
        <div class="app-main">
            <Sidebar />
            <MSidebar/>
            <div class="app-body">
                <router-view></router-view>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';
import Sidebar from '@/components/layout/Sidebar.vue';
import MSidebar from '@/components/layout/MSidebar.vue';

export default {
    components: {
        Header,
        Footer,
        Sidebar,
        MSidebar
    },
    mounted(){
        window.onclick = function(event) {
            var i;
            if (!event.target.matches('.account-menu')) {
                var dropdowns = document.getElementsByClassName("user-menu");
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }

            if (!event.target.matches('.open-menu')) {
                var dropdowns2 = document.getElementsByClassName("m-menu-full");
                for (i = 0; i < dropdowns2.length; i++) {
                    var openDropdown2 = dropdowns2[i];
                    if (openDropdown2.classList.contains('show')) {
                        openDropdown2.classList.remove('show');
                    }
                }
            }

            if (!event.target.matches('.dropdown-menu-btn')) {
                var dropdowns = document.getElementsByClassName("dropdown-menu-content");
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) {
                    openDropdown.classList.remove('show');
                }
                }
            }
        }
    }
}
</script>